module.exports = "/_next/static/images/you_front-28db2f9891cca9d213a9683807b1b5f1.jpg";